<template>
  <div class="container">
    <content-header :data="[{text:'店铺管理', path: ''}]"></content-header>
    <div class="content">
      <div class="content-bar">
        <div class="search-entry">
          <el-button type="primary" icon="plus" @click="initNewHandle">添加</el-button>
        </div>
        <div class="search-entry">
            <el-input
              placeholder="店名/手机号"
              v-model="keywords">
            </el-input>
        </div>
        <div class="search-btn">
          <el-button type="primary" @click="searchHandle">查询</el-button>
        </div>
      </div>
      <!-- 列表区域 -->
      <div class="content-list">
        <el-table
          :data="tableData"
          border
          stripe>
          <el-table-column
            prop="number"
            label="店铺编号"
            width="100"
            fixed>
          </el-table-column>
          <el-table-column
            prop="name"
            label="店铺名称"
            width="200"
            fixed>
          </el-table-column>
          <el-table-column
            prop="address"
            label="地址"
            width="200">
          </el-table-column>
          <el-table-column
            prop="ownerName"
            label="店老板姓名">
          </el-table-column>
          <el-table-column
            prop="ownerPhone"
            label="店老板手机"
            width="120">
          </el-table-column>
          <el-table-column
            prop="managerName"
            label="负责人姓名">
          </el-table-column>
          <el-table-column
            prop="managerPhone"
            label="负责人手机"
            width="120">
          </el-table-column>
          <el-table-column
            prop="created"
            label="创建时间"
            width="180">
          </el-table-column>
          <el-table-column
            fixed="right"
            label="操作"
            width="150">
            <template slot-scope="scope">
              <el-button @click="viewHandle(scope.row)" type="text" size="small" >查看</el-button>
              <el-button @click="initEditHandle(scope)" type="text" size="small" >修改</el-button>
              <el-button @click="deleteHandle(scope)" type="text" size="small" >删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div class="pagination" v-if="total > pageSize">
          <el-pagination
            @size-change="pageSizeChange"
            @current-change="curPageChange"
            :current-page="curPage"
            :page-sizes="[10, 20, 30, 40]"
            :page-size="pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total">
          </el-pagination>
        </div>
      </div>
      <!-- 新建弹出区域 -->
      <div class="new-wrap">
        <el-dialog :title="curObj.id ? '修改店铺' : '添加店铺'" :visible.sync="isObjShow">
          <el-form :model="curObj" :rules="curObjRules" ref="curObjForm" label-position="right" label-width="0px">
            <el-form-item prop="name" label="店铺名称" :label-width="formLabelWidth">
              <el-input name="name" v-model="curObj.name" auto-complete="off"></el-input>
            </el-form-item>
            <el-form-item prop="number" label="店铺编号" :label-width="formLabelWidth">
              <el-input name="number" v-model="curObj.number" auto-complete="off"></el-input>
            </el-form-item>
            <el-form-item label="省/市/县" :label-width="formLabelWidth">
              <el-row :gutter="10">
                <el-col :span="6">
                  <el-form-item prop="provinceId">
                    <el-select v-model="curObj.provinceId" value-key="id" placeholder="请选择省/直辖市" @change="provinceChange">
                      <el-option
                        v-for="item in provinceIds"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id">
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item prop="cityId">
                    <el-select v-model="curObj.cityId" value-key="id" placeholder="请选择市" @change="cityChange">
                      <el-option
                        v-for="item in cityIds"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id">
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item prop="districtId">
                    <el-select v-model="curObj.districtId" value-key="id" placeholder="请选择区/县">
                      <el-option
                        v-for="item in districtIds"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id">
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-form-item>
            <el-form-item prop="regionId" label="区域" :label-width="formLabelWidth">
              <el-select v-model="curObj.regionId" clearable value-key="id" placeholder="请选择区域">
                <el-option
                  v-for="item in regionIds"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item prop="address" label="地址" :label-width="formLabelWidth">
              <el-input name="address" v-model="curObj.address" auto-complete="off"></el-input>
            </el-form-item>
            <el-form-item prop="ownerName" label="店老板姓名" :label-width="formLabelWidth">
              <el-input name="ownerName" v-model="curObj.ownerName" auto-complete="off"></el-input>
            </el-form-item>
            <el-form-item prop="ownerPhone" label="店老板手机号" :label-width="formLabelWidth">
              <el-input name="ownerPhone" v-model="curObj.ownerPhone" auto-complete="off"></el-input>
            </el-form-item>
            <el-form-item prop="managerName" label="负责人姓名" :label-width="formLabelWidth">
              <el-input name="managerName" v-model="curObj.managerName" auto-complete="off"></el-input>
            </el-form-item>
            <el-form-item prop="managerPhone" label="负责人手机号" :label-width="formLabelWidth">
              <el-input name="managerPhone" v-model="curObj.managerPhone" auto-complete="off"></el-input>
            </el-form-item>

          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button @click="isObjShow = false">取 消</el-button>
            <el-button type="primary" @click="confirmHandle">确 定</el-button>
          </div>
        </el-dialog>
      </div>
      <!-- dialog -->
      <div class="view-wrap">
        <el-dialog title="店铺详情" :visible.sync="isShopView">
          <shop-view :data="selectedShop"></shop-view>
          <div slot="footer" class="dialog-footer">
            <el-button @click="isShopView = false">关闭</el-button>
          </div>
        </el-dialog>
      </div>
    </div>
  </div>
</template>

<script type="text/babel">
  import ShopView from 'components/ShopView'
  import ShopModel from 'models/shop'

  export default {
    components: {
      ShopView
    },
    data () {
      return {
        keywords: '',
        tableData: [],
        isObjShow: false,
        provinceIds: [],
        cityIds: [],
        districtIds: [],
        regionIds: [],
        curObj: {
          id: '',
          name: '',
          number: '',
          provinceId: '',
          cityId: '',
          districtId: '',
          regionId: '',
          address: '',
          ownerName: '',
          ownerPhone: '',
          managerName: '',
          managerPhone: ''
        },
        formLabelWidth: '120px',
        curObjRules: {
          name: [{ required: true, message: '请输入名称', trigger: 'blur' }],
          number: [{ required: true, message: '请输入编号', trigger: 'blur' }],
          provinceId: [{ required: true, message: '请选择省', trigger: 'blur' }],
          cityId: [{ required: true, message: '请选择市', trigger: 'blur' }],
          districtId: [{ required: true, message: '请选择区/县', trigger: 'blur' }],
          regionId: [{ required: true, message: '请选择区域', trigger: 'blur' }],
          address: [{ required: true, message: '请输入地址', trigger: 'blur' }],
          ownerName: [{ required: true, message: '请输入姓名', trigger: 'blur' }],
          ownerPhone: [{ required: true, message: '请输入手机号', trigger: 'blur' }],
          managerName: [{ required: true, message: '请输入姓名', trigger: 'blur' }],
          managerPhone: [{ required: true, message: '请输入手机号', trigger: 'blur' }],
        },
        curPage: 1,
        pageSize: 10,
        total: 0,
        isShopView: false,
        selectedShop: {},
      }
    },
    created () {
      this.getObjList()
      this.curObj.provinceId = 510000
      this.curObj.cityId = 510100
      ShopModel.findArea({parentId: 0}).then(res => {
        this.provinceIds = res
      })
      ShopModel.findRegion({provinceId: this.curObj.provinceId}).then(res => {
        // console.log(res)
        this.regionIds = res
      })
    },
    methods: {
      pageSizeChange (size) {
        this.pageSize = size
        this.getObjList()
      },
      curPageChange (page) {
        this.curPage = page
        this.getObjList()
      },
      getObjList (opts) {
        const _opts = {
          curPage: this.curPage,
          pageSize: this.pageSize,
          keywords: this.keywords
        }
        // 合并参数
        if (typeof opts === 'object') Object.assign(_opts, opts)
        //
        ShopModel.find(_opts).then(res => {
          this.tableData = res.rows
          this.total = res.total
        })
      },
      //
      deleteHandle (item) {
        this.$confirm('是否确认删除？')
          .then(_ => {
            ShopModel.delete({
              id: item.row.id,
            }).then(() => {
              this.tableData.splice(item.$index, 1)
              this.$message({ message: '删除成功', type: 'success' })
            }).catch(err => {
              this.$message({ message: err.message, type: 'error' })
            })
          })
          .catch(_ => {})
      },
      confirmHandle () {
        this.$refs.curObjForm.validate(valid => {
          if (!valid) return
          if (this.curObj.id) return this.editHandle()
          this.newHandle()
        })
      },
      initNewHandle () {
        this.curObj = {
          id: '',
          name: '',
          number: '',
          provinceId: 510000,
          cityId: 510100,
          districtId: '',
          regionId: '',
          address: '',
          ownerName: '',
          ownerPhone: '',
          managerName: '',
          managerPhone: ''
        }
        ShopModel.findArea({parentId: 510000}).then(res => {
          this.cityIds = res
        })
        ShopModel.findArea({parentId: 510100}).then(res => {
          this.districtIds = res
        })
        this.isObjShow = true
      },
      newHandle () {
        ShopModel.create(this.curObj).then(() => {
          this.getObjList()
          this.isObjShow = false
          this.$message({ message: '添加成功', type: 'success' })
        }).catch(err => {
          this.$message({ message: err.message, type: 'error' })
        })
      },
      initEditHandle (item) {
        this.curObj = {
          id: item.row.id,
          name: item.row.name,
          number: item.row.number,
          provinceId: item.row.provinceId,
          cityId: item.row.cityId,
          districtId: item.row.districtId,
          regionId: item.row.regionId,
          address: item.row.address,
          ownerName: item.row.ownerName,
          ownerPhone: item.row.ownerPhone,
          managerName: item.row.managerName,
          managerPhone: item.row.managerPhone
        }
        ShopModel.findArea({parentId: this.curObj.provinceId}).then(res => {
          this.cityIds = res
        })
        ShopModel.findArea({parentId: this.curObj.cityId}).then(res => {
          this.districtIds = res
        })
        this.isObjShow = true
      },
      editHandle () {
        ShopModel.update(this.curObj).then(() => {
          this.getObjList()
          this.isObjShow = false
          this.$message({ message: '更新成功', type: 'success' })
        }).catch(err => {
          this.$message({ message: err.message, type: 'error' })
        })
      },
      searchHandle () {
        this.getObjList()
      },
      provinceChange (value) {
        ShopModel.findArea({parentId: value}).then(res => {
          this.cityIds = res
          this.curObj.cityId = res[0].id
          this.cityChange(this.curObj.cityId)
        })
      },
      cityChange (value) {
        ShopModel.findArea({parentId: value}).then(res => {
          this.districtIds = res
          this.curObj.districtId = res[0].id
        })
      },
      viewHandle (row, event, column) {
        ShopModel.get({id: row.id}).then(res => {
          this.selectedShop = res
          this.isShopView = true
        })
      },
    }
  }
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
.container
  min-height: 100%
  background-color: #fff
  .content
    .content-bar
      padding: 20px
      .search-entry
        display: inline-block
        vertical-align: top
        margin-right: 10px
        margin-bottom: 10px
      .search-btn
        display: inline-block
        vertical-align: top
    .content-list
      padding-left: 20px
      padding-right: 20px
      padding-bottom: 40px
      .pagination
        margin-top: 10px
    .new-wrap
      .el-input
        width: 300px
      .form-title
        padding-top: 10px
        padding-bottom: 10px
        font-size: 12px
        color: #aaa
      .check-title
        text-align: right
        display: inline-block
        vertical-align: middle
        width: 90px
        font-size: 14px
        color: #48576a
        line-height: 1
        padding: 11px 12px 11px 0
        box-sizing: border-box
      .avatar-uploader
          border: 1px dashed #d9d9d9
          border-radius: 6px
          cursor: pointer
          position: relative
          overflow: hidden
          width: 180px
          &:hover
            border-color: #409EFF
          .avatar-uploader-icon
            font-size: 28px
            color: #8c939d
            width: 178px
            height: 178px
            line-height: 178px
            text-align: center
          .avatar
            width: 178px
            height: 178px
            display: block
</style>



// WEBPACK FOOTER //
// src/views/Shop.vue